// import "@google/model-viewer";
import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  modelAtom,
  preFixAtom,
  upholsteryAtom,
  uploadImageAtom,
} from "../../state";
import { GET_URL } from "../../constans";
const textures = {};

const ShareUpholsteryModelViewer = ({ selectedProduct }) => {
  const upholstery = useRecoilValue(upholsteryAtom);
  const [modelViewer, setModelViewer] = useState(document.querySelector("#model-viewer"))
  const [modelAtomValue, setModelAtomValue] = useRecoilState(modelAtom);
  const preFix = useRecoilValue(preFixAtom);
  const getCheckSupport = localStorage.getItem('checkSupport')
  const uploadImage = useRecoilValue(uploadImageAtom)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setModelViewer(document.querySelector("#model-viewer"))
    }, 500);
    // Cancel the interval after 5 seconds (5000 milliseconds)
    setTimeout(() => {
      clearInterval(intervalId);
    }, 500);
  }, []);

  // in-built fabric apply at that time apply uv model
  useEffect(() => {
    if (upholstery?.partWiseFabric) {
      (async () => {
        setTimeout(async () => {
          await getUVModel()
        }, 500)
      })()
    }
  }, [upholstery?.partWiseFabric, modelAtomValue, modelViewer]);

  useEffect(() => {
    updateMaterial();
  }, [upholstery.partWiseFabric, modelAtomValue.src, modelViewer]);

  const getUVModel = async () => {
    try {
      if (modelViewer?.model) {
        const model = modelViewer.model;
        if (!model) return;

        let keys = uploadImage ? ['Fabric'] : Object.keys(upholstery.partWiseFabric)
        if (keys.length === 0) {
          return;
        }
        const parts = model[Object.getOwnPropertySymbols(model)[1]];
        let meterialIndexies = [];

        for (const key of keys) {
          parts.forEach((part) => {
            if (key === part.name) {
              const index = part.initialMaterialIdx
              meterialIndexies = {
                ...meterialIndexies,
                [key]: index,
              };
            }
          });
        }
        for (const fabricKey of keys) {
          if (typeof meterialIndexies[fabricKey] === 'number' && isFinite(meterialIndexies[fabricKey])) {
            const material = modelViewer.model.materials[meterialIndexies[fabricKey]];
            const diffuse_map = material.pbrMetallicRoughness['baseColorTexture'].texture.sampler;
            const normal_map = material.normalTexture.texture.sampler;
            const checkImage = uploadImage;
            const xValue = Number(!checkImage ? upholstery.partWiseFabric[fabricKey].repeatX : inputValue?.Horizontal)
            const yValue = Number(!checkImage ? upholstery.partWiseFabric[fabricKey].repeatY : inputValue?.Vertical)
            const scale = {
              u: xValue || 0,
              v: yValue || 0,
            };
            if (scale.u || scale.v) {
              modelViewer.exposure = 0.65
              diffuse_map.setScale(scale);
              normal_map.setScale(scale);
            }
          }
        }
      }
    } catch (error) {
    }
  };

  const createAndApplyTexture = async (channel, modelPartName, fabricImg, mergeImage) => {
    const base64Image = fabricImg?.search('data:image/png;base64') !== -1 ? true : false
    let imageConvert = fabricImg
    if (getCheckSupport === 'true' && !base64Image) {
      imageConvert = fabricImg?.replaceAll('.jpeg', '.webp')
    }
    try {
      if (modelViewer?.model) {
        let texture = null;
        if (textures[fabricImg]) {
          texture = textures[fabricImg];
        } else {
          texture = await modelViewer.createTexture(base64Image ? fabricImg : GET_URL(imageConvert));
          textures[fabricImg] = texture;
        }

        const model = modelViewer.model;
        const parts = model[Object.getOwnPropertySymbols(model)[1]];

        const meterialIndexies = [];
        const partWiseIndex = {};

        parts.forEach((part) => {
          const index = part.initialMaterialIdx
          partWiseIndex[index] = part.name;
          if (modelPartName === part.name) {
            meterialIndexies.push(index);
          }
        });

        meterialIndexies.forEach(index => {
          const material = modelViewer.model.materials[index];
          const pbrMR = material.pbrMetallicRoughness;

          if (channel.includes("base") || channel.includes("metallic")) {
            pbrMR[channel].setTexture(texture);
          } else {
            material[channel].setTexture(texture);
          }
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const updateMaterial = async () => {
    let keys, material;
    keys = upholstery.partWiseFabric ? Object.keys(upholstery.partWiseFabric) : []
    material = upholstery;

    if (keys.length === 0) {
      return;
    }
    for (const key of keys) {
      if (material.partWiseFabric[key]) {
        await createAndApplyTexture(
          "baseColorTexture",
          key,
          material.partWiseFabric[key].diffuse
        );
        await createAndApplyTexture(
          "metallicRoughnessTexture",
          key,
          material.partWiseFabric[key].metallicRoughness
        );
        await createAndApplyTexture(
          "normalTexture",
          key,
          material.partWiseFabric[key].normal
        );
      }
    }

  };

  if (modelViewer) {
    modelViewer.addEventListener("load", (data) => {
      const childrenName = document.getElementsByClassName('card mt-4 cursor-pointer p-0 me-md-4 mb-lg-0 mb-4 align-items-center active-category')?.[0]?.children[1]?.children[0]?.textContent
      if (childrenName === `${selectedProduct?.seriesName} ${upholstery?.name}`) {
        updateMaterial();
      }
    });
  }

  document.querySelector("#model-viewer")?.addEventListener("progress", (event) => {
    if (event.detail.totalProgress === 1) {
      setModelAtomValue({
        ...modelAtomValue,
        loading: 100,
      })
    }
  })
  if (modelAtomValue.src.replace('app', preFix) && preFix) {
    return (
      <>
        <div id="card" style={{
          opacity: modelAtomValue.loading === 100 ? '1' : '0',
          transition: 'opacity 1s ease-in-out'
        }}>
          <model-viewer
            tone-mapping="commerce"
            src={modelAtomValue.src.replace('app', preFix)}
            camera-controls
            disable-pan
            style={{ height: "57vh", width: "100%" }}
            id="model-viewer"
          ></model-viewer>
        </div>
      </>
    );
  } else {
    return <></>
  }
};

export default ShareUpholsteryModelViewer;
